const ReCaptcha = require('./ReCaptcha').default
const loadReCaptcha = require('./loadReCaptcha').default

module.exports = {
    ReCaptcha,
    loadReCaptcha
}